export const b2bReferrerPatterns = [
  /^https?:\/\/dashboard\.properstar\.com(?:[/:?#]|$)/,
  /^https?:\/\/dashboard-[^./?#]+\.properstar\.com(?:[/:?#]|$)/,
  /^https?:\/\/my\.listglobally\.com(?:[/:?#]|$)/,
  /^https?:\/\/my-[^./?#]+\.listglobally\.com(?:[/:?#]|$)/,
  /^https?:\/\/pz-puzzle-stagingslot\.azurewebsites\.net(?:[/:?#]|$)/,
]

export const b2cReferrerPatterns = [
  /^https?:\/\/www2\.properstar\.(?:\w{2,}(?:\.\w{2,})?)(?:[/:?#]|$)/,
  /^https?:\/\/www\.properstar\.(?:\w{2,}(?:\.\w{2,})?)(?:[/:?#]|$)/,
  /^https?:\/\/dev\.properstar\.(?:\w{2,}(?:\.\w{2,})?)(?:[/:?#]|$)/,
  /^https?:\/\/release\.properstar\.(?:\w{2,}(?:\.\w{2,})?)(?:[/:?#]|$)/,
  /^https?:\/\/acproperty\.listglobally\.com(?:[/:?#]|$)/,
  /^https?:\/\/acproperty-dev\.listglobally\.com(?:[/:?#]|$)/,
  /^https?:\/\/acproperty-release\.listglobally\.com(?:[/:?#]|$)/,
  /^https?:\/\/www2\.acproperty\.com\.au(?:[/:?#]|$)/,
  /^https?:\/\/acproperty\.com\.au(?:[/:?#]|$)/,
  /^https?:\/\/www2\.sodichan\.com(?:[/:?#]|$)/,
  /^https?:\/\/dev\.sodichan\.com(?:[/:?#]|$)/,
  /^https?:\/\/release\.sodichan\.com(?:[/:?#]|$)/,
  /^https?:\/\/www\.sodichan\.com(?:[/:?#]|$)/,
]

export const allowedPatterns = [...b2bReferrerPatterns, ...b2cReferrerPatterns]

export const isPowersiteReferrer = (referrer: string) => {
  return b2cReferrerPatterns.some((pattern) => pattern.test(referrer))
}
